import api from './client';

const rangeParams = (start, end) => ({ start: start.toISOString(), end: end.toISOString() });

export const getProjectEvents = (projectId, start, end) =>
  api.get('/calendar/events', { params: { project: projectId, ...rangeParams(start, end) } });
export const getMyEvents  = (start, end) => api.get('/calendar/my', { params: rangeParams(start, end) });
export const getBirthdays = () => api.get('/calendar/birthdays');
export const getCalendarPrefs  = () => api.get('/calendar/prefs');
export const saveCalendarPrefs = (prefs) => api.put('/calendar/prefs', prefs);
export const createEvent = (data) => api.post('/calendar/events', data);
export const updateEvent = (id, data) => api.put(`/calendar/events/${id}`, data);
export const deleteEvent = (id) => api.delete(`/calendar/events/${id}`);
